import {QuantityType} from 'smag-commons/dto/msg';
import {EntityMeasureAggregationType} from 'smag-commons/dto/api';

export class AggregationConfig {
    pollDuration: number; // in seconds (back in time, starting from "now")
    color: string;
}

export class AppColors {
    consolidatedGenerated: string;
    consolidatedSelfConsumed: string;
    consolidatedShared: string;
    consolidatedAbsorbed: string;
    consolidatedSelfConsumedRatio: string;
    consolidatedIncentiveShared: string;
    consolidatedInjected: string;
    consolidatedConsumed: string;
    consolidatedAbsorptionShare: string;
    consolidatedEffectiveInjected: string;
    consolidatedTIP: string;
    consolidatedInjectionShare: string;
    consolidatedCacv: string;
    consolidatedSharedRatio: string;
    effectiveInjectedEnergy: string;
    incentivizedEffectiveInjected: string;
    incentivizedConsolidatedEffectiveInjected: string;
    incentivizedShared: string;
    incentivizedConsolidatedShared: string;
    selfConsumedRatio: string;
    sharedEnergyRatio: string;
    selfConsumedEnergy: string;
    activePower: string;
    reactivePower: string;
    thermalPower: string;
    sharedPower: string;
    injectedPower: string;
    curtailedPower: string;
    storagePower: string;
    consumedPower: string;
    absorbedPower: string;
    generatedPower: string;
    stateOfCharge: string;
    voltage: string;
    phaseAngle: string;
    current: string;
    frequency: string;
    energy: string;
    temperature: string;
    radiation: string;
    dewPoint: string;
    windChill: string;
    heatIndex: string;
    pressure: string;
    humidity: string;
    rainfall: string;
    uv: string;
    liftedIndex: string;
    cloudCoverage: string;
    windSpeed: string;
    windDir: string;
    windGusts: string;
    brightness: string;
    presence: string;
    cost: string;
    highCost: string;
    lowCost: string;
    highPrice: string;
    lowPrice: string;
    incentive: string;
    totalIncentive: string;
    tip: string;
    cacv: string;
    consolidatedIncentive: string;
    consolidatedIncentiveSharedRatio: string;
    incentiveSharedEnergyRatio: string;
}

/**
 * Shared module configuration properties.
 */
export class SharedConfig {
    colors: AppColors;
    quantityColors: { [qt in QuantityType]?: string };
    aggregationColors: { [at in EntityMeasureAggregationType]?: string };
    aggregationColorsConsolidation: { [at in EntityMeasureAggregationType]?: string };
    defaultColor: string;
    gridColor: string;
    tooltipBorderColor: string;
    tooltipBackgroundColor: string;
    selectionLineColor: string;
}
